import { BlokProps, withStoryblokEditable } from "@helpers/StoryblokHelpers"
import { ServiceTypeStoryblok, VaccinationClinicPageStoryblok, VaccinationClinicTypeStoryblok } from "@storyblok-types"
import { StoryblokServerComponent } from "@storyblok/react/rsc"
import PageContainer from "@ui-library/layout/PageContainer"

interface VaccinationClinicPageProps {
  blok: BlokProps<VaccinationClinicPageStoryblok>["blok"]
  vaccination_clinic?: VaccinationClinicTypeStoryblok
  services?: ServiceTypeStoryblok[]
}

export const VaccinationClinicPage = ({ blok, vaccination_clinic, services }: VaccinationClinicPageProps) => {
  return (
    <PageContainer background={blok.background} extraHeight={false} {...withStoryblokEditable(blok)}>
      {blok.body?.map(nestedBlok => (
        <StoryblokServerComponent
          blok={nestedBlok}
          vaccination_clinic={vaccination_clinic}
          services={services}
          key={nestedBlok._uid}
        />
      ))}
    </PageContainer>
  )
}

export default VaccinationClinicPage
